import { render, staticRenderFns } from "./Form4473Changes.vue?vue&type=template&id=25d45535"
import script from "./Form4473Changes.vue?vue&type=script&lang=js"
export * from "./Form4473Changes.vue?vue&type=script&lang=js"
import style0 from "./Form4473Changes.vue?vue&type=style&index=0&id=25d45535&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports